import { isPageVisible } from "./pageVisibility";

export const WORKSPACE_SETTINGS_PATH = "/settings/company";

export const SETTINGS_PAGES = [
  { id: "company", to: WORKSPACE_SETTINGS_PATH, labelKey: "company" },
  { id: "team", to: "/settings/team", labelKey: "team" },
  { id: "modules", to: "/settings/modules", labelKey: "modules" },
  { id: "integrations", to: "/settings/integrations", labelKey: "integrations" },
  { id: "automation", to: "/settings/ai", labelKey: "automation" },
  { id: "billing", to: "/settings/billing", labelKey: "billing" },
].filter(({ to }) => isPageVisible(to));

export const COMPANY_SETTINGS_TABS = [
  { to: WORKSPACE_SETTINGS_PATH, labelKey: "details", end: true },
  { to: "/settings/company/branding", labelKey: "branding" },
  { to: "/settings/company/bank-accounts", labelKey: "bankAccounts" },
];

// Keep old bookmarks, including descendants, at their corresponding destination.
export const LEGACY_SETTINGS_REDIRECTS = [
  { path: "/workspace-settings", redirect: WORKSPACE_SETTINGS_PATH },
  { path: "/company-account", redirect: WORKSPACE_SETTINGS_PATH },
  { path: "/company-account/branding/*", redirect: "/settings/company/branding" },
  { path: "/company-account/bank-accounts/*", redirect: "/settings/company/bank-accounts" },
  { path: "/company-account/features/*", redirect: WORKSPACE_SETTINGS_PATH },
  { path: "/company-account/billing/*", redirect: "/settings/billing" },
  { path: "/company-account/*", redirect: WORKSPACE_SETTINGS_PATH },
  { path: "/all-accounts/*", redirect: "/settings/team" },
  { path: "/agent-config/*", redirect: "/settings/integrations" },
  { path: "/billing", redirect: "/settings/billing" },
];

export function getSettingsPage(pathname) {
  return SETTINGS_PAGES.find(
    ({ to }) => pathname === to || pathname.startsWith(`${to}/`),
  );
}

export function isWorkspaceSettingsPath(pathname) {
  return Boolean(getSettingsPage(pathname));
}
